export enum SocialNetwork {
  Facebook = 'Facebook',
  Twitter = 'Twitter',
  Linkedin = 'Linkedin',
  Youtube = 'Youtube',
}
